<template>
  <div>
    <base-crud
      crudName="Adicionais da Estação"
      newText="Novo Adicional de Estação"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Adicionais de Estação",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content:
            "Aqui temos todos os Adicionais de Estação já cadastrados, e podemos edita-los clicando em <i class='fas fa-pencil-alt'></i>. Clicando em Novo Adicional de Estação podemos cadatrar novos Adicionais. Os Adicionais de Estação, são tudo aquilo que pode conter nas estações. Exemplo: Se a Estação tiver Wi-fi você pode cadastrar um Adicional com o nome Wi-fi e na hora do cadastro da Estação de Trabalho você pode selecionar que a Estação contém Wi-fi.",
        },
      ],
      table: "workstation_detailsDetailsTable",
      // pages: [],
      // url: '',
      columns: ["id", "title", "pre_selected", "company_id", "actions"],
      tableData: ["id", "title", "pre_selected", "company_id"],
      options: {
        sortable: ["id", "title", "pre_selected", "company_id"],
        filterable: ["id", "title", "pre_selected", "company_id"],
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Titulo",
          pre_selected: "Pré selecionado",
          company_id: "Empresa",
          actions: "Ações",
        },
        templates: {
          pre_selected: function (h, row, index) {
            return row.pre_selected == 1 ? "Sim" : "Não";
          },
          company_id: function (h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];
          requestData.params.with = ["company"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "workstation_details/",

      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 31) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        company_id: "company[company_name]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/WorkstationsDetails/Crud.vue